<template>
  <template v-if="view==='listar'">

    <button class="flex items-center px-2 py-1 text-white bg-pink-500 rounded-md hover:bg-pink-600 focus:outline-none"
        style="white-space: nowrap;"  @click="$emit('updateValues', {'view': 'notificar_juridica_embargo'});$emit('data', data);"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-5 mr-1">
        <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
      </svg>

      Jurídica
    </button>

  </template>
</template>
<script>

export default {
  name: 'BotonNotificarJuridicaEmbargoPersonaComponent',
  props: ['view', 'data'],
  emits: ['updateValues', 'data']
}
</script>
